import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";

interface ConfirmAddAreaModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  area: { formatted_address: string; place_id: string } | null;
}

const ConfirmAddAreaModal: React.FC<ConfirmAddAreaModalProps> = ({
  open,
  onClose,
  onConfirm,
  area,
}) => {
  if (!area) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        position="absolute"
        top="50%"
        left="50%"
        bgcolor="background.paper"
        borderRadius="8px"
        sx={{
          transform: "translate(-50%, -50%)",
          width: "300px",
          padding: "16px",
          boxShadow: 24,
        }}
      >
        <Typography variant="h6" marginBottom={2}>
          Confirm Add Area
        </Typography>
        <Typography variant="body1" marginBottom={2}>
          Are you sure you want to add this area?
        </Typography>
        <Typography variant="body2" marginBottom={4}>
          <strong>{area.formatted_address}</strong>
        </Typography>
        <Box display="flex" justifyContent="space-between">
          <Button variant="contained" color="primary" onClick={onConfirm}>
            Confirm
          </Button>
          <Button variant="outlined" color="secondary" onClick={onClose}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmAddAreaModal;
